var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicsvgDownload7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.050000,-0.050000)",
    fill: "#e19b3c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M793 4199 c-89 -26 -188 -101 -248 -187 l-55 -79 -5 -1096 c-8 -1514 -76 -1417 992 -1417 l659 0 -3 -185 -3 -185 -191 7 c-352 12 -543 -185 -411 -425 81 -147 43 -141 1012 -147 974 -6 949 -9 1040 140 144 236 -22 425 -375 425 l-225 0 0 184 0 185 688 5 689 6 86 60 c57 39 106 98 142 169 l55 108 0 646 c0 598 -3 647 -36 665 -95 51 -104 13 -104 -459 l0 -439 -1945 0 -1945 0 6 835 c6 949 4 935 164 1020 l88 46 1714 -6 c1697 -5 1716 -5 1770 -46 123 -92 137 -131 148 -405 l10 -254 60 0 60 0 6 240 c8 345 -71 501 -294 579 -98 35 -3435 45 -3549 10z m3703 -2305 c-11 -163 -44 -231 -145 -294 -101 -62 -3483 -63 -3585 -1 -107 65 -202 332 -152 426 5 8 882 15 1950 15 l1941 0 -9 -146z m-1656 -659 l0 -185 -285 3 -285 3 -5 182 -5 182 290 0 290 0 0 -185z m602 -372 c52 -64 48 -135 -11 -194 l-49 -49 -818 0 c-926 0 -924 0 -924 150 0 152 -3 152 935 146 l829 -6 38 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1973 1847 c-32 -32 -12 -107 32 -117 25 -6 287 -9 583 -6 571 6 601 12 566 103 -13 34 -1147 53 -1181 20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload7);
export default __webpack_public_path__ + "static/media/picsvg_download(7).723134ecf62bd41bbb0ab3814a77152a.svg";
export { ForwardRef as ReactComponent };